import Model, { attr, belongsTo } from '@ember-data/model';

export const TEXT_MAX_LENGTH = 5000;
export const MESSAGE_STATUSES = {
  SENDING: 'sending',
  DELIVERED: 'delivered',
  FAILED: 'failed',
};

export default class MessagingMessageModel extends Model {
  @belongsTo('messaging-conversation', { async: false }) conversation;
  @belongsTo('messaging-user', { async: false, inverse: null }) user;

  @attr('boolean') isOwn;
  @attr('boolean') isSystem;

  // Renamed "content" in serializer as it collides with reserved attribute name.
  @attr('string') text;

  @attr('string') localId;
  @attr('string', { defaultValue: MESSAGE_STATUSES.DELIVERED }) status;

  @attr('date') createdAt;
  @attr('date') deletedAt;

  @attr() readMemberships;
}
